import styled from 'styled-components'

export const Container = styled.div<{ open: boolean; length: number }>`
    background: #fff;
    border-radius: 3px;
    box-sizing: border-box;
    min-height: 48px;

    .ListHeader {
        background: #f5f5f5;
        display: flex;
        padding: 10px;
        width: 100%;
        height: 100%;
        max-height: 48px;

        .Title {
            display: flex;
            flex: 1;
            align-items: center;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            text-transform: uppercase;
            color: #364159;

            .Icon {
                font-weight: normal;
                color: #c43535;
                margin-right: 10px;
            }
        }

        .Info {
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #868695;

            span:first-child {
                font-weight: 600;
                font-size: 14px;
                color: #c43535;
                margin-right: 3px;
            }

            .Icon {
                font-weight: normal;
                font-size: 14px;
                line-height: 16px;
                color: #37a3ef;
                margin-left: 10px;
                cursor: pointer;
                transform: rotate(${({ open }) => (open ? 180 : 0)}deg);
                transition: 0.3s all;
            }
        }
    }

    .ListBody {
        height: ${({ open, length }) => (open ? `${95 + length * 32}px` : '0px')};
        overflow: hidden;
        opacity: ${({ open }) => (open ? 1 : 0)};
        transition: 0.3s all 0s;

        .Top {
            border-bottom: 1px solid #dadada;
            padding: 10px;
            display: flex;

            .Info {
                flex: 1;
                color: #868695;
                min-width: 180px;
                max-width: 180px;

                .Label {
                    font-weight: 400;
                    font-size: 12px;
                    text-transform: uppercase;
                }

                .Number {
                    font-weight: 400;
                    font-size: 12px;
                    color: #364159;

                    span {
                        font-weight: 600;
                        font-size: 16px;
                        line-height: 12px;
                    }
                }
            }

            .Count {
                width: 90px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .Label {
                    font-weight: normal;
                    font-size: 11px;
                    line-height: 16px;
                    color: #364159;
                    text-transform: uppercase;
                }

                .Number {
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 16px;
                    color: #868695;
                    flex: 1;
                    display: flex;
                    align-items: center;

                    span {
                        font-size: 16px;
                        font-weight: 600;
                        color: #c43535;
                    }
                }
            }
        }

        .Bottom {
            padding: 10px;
        }
    }
`

export const RowContainer = styled.div<{ preventionColor: string; mitigationColor: string; color: string }>`
    display: flex;
    margin-bottom: 16px;

    .Info {
        flex: 1;
        display: flex;
        min-width: 180px;
        max-width: 180px;

        .Id {
            font-weight: 600;
            font-size: 11px;
            line-height: 16px;
            color: #37a3ef;
            margin-right: 13px;
            cursor: pointer;
        }

        .Label {
            display: flex;
            font-weight: normal;
            font-size: 11px;
            line-height: 16px;
            color: ${({ color }) => color};
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .Icon {
                margin-right: 5px;
            }
        }
    }

    .Count {
        width: 90px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .Number {
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
            color: #868695;
            flex: 1;
            display: flex;
            align-items: center;

            span {
                font-size: 16px;
                font-weight: 600;
            }

            &.Mitigation {
                span {
                    color: ${({ mitigationColor }) => mitigationColor};
                }
            }

            &.Prevention {
                span {
                    color: ${({ preventionColor }) => preventionColor};
                }
            }
        }
    }
`
